<template>
  <div class="card card-content">
    <div class="card-header">
      <breadcrumb :label="label"></breadcrumb>
      <h1>Tableau de bord</h1>
      <div class="actions">
        <a class="btn btn-link" href="" v-link="{path: '/add'}">Créer</a>
        <a class="btn btn-link" href="#">Exporter</a>
        <!--a class="btn btn-link" href="#">Imprimer</a-->
      </div>
    </div>
    <div class="Calendar"></div>
    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" href="" v-link="{path: '/add'}">Créer</a>
        <a class="btn btn-link" href="#">Exporter</a>
        <!--a class="btn btn-link" href="#">Imprimer</a-->
      </div>
    </div>
  </div>
</template>

<script>
  // Npm imports
  import $ from 'jquery'
  import moment from 'moment'

  import 'fullcalendar'
  import 'fullcalendar/dist/locale/fr.js'

  // Vuex
  import { meetings, selectedDay, selectedUsers, meetingDeleted, contact, phases, project, contacts } from 'src/vuex/getters'
  import { getMeetings, getMeeting, selectDay } from 'src/vuex/actions/meetingActions'
  import { getContact, getContacts } from 'src/vuex/actions/contactActions'
  import { getProject } from 'src/vuex/actions/projectActions'
  import { getPhases } from 'src/vuex/actions/phaseActions'

  // import { formatMeetings } from 'src/utils/fullcalendar'
  import { formatMeetingsWithUrl } from 'src/utils/fullcalendar'

  import Breadcrumb from '../nav/Breadcrumb.vue'

  export default{
    vuex: {
      getters: { meetings, selectedDay, selectedUsers, meetingDeleted, contact, phases, project, contacts },
      actions: { getMeetings, getMeeting, selectDay, getContact, getPhases, getProject, getContacts }
    },
    data () {
      return {
        label: [['', 'Tableau de bord']]
      }
    },
    ready () {
      let vm = this
      let calendarview = 'agenda'

      this.getPhases()
      this.getContacts()
      .then(() => {
        $('.Calendar').fullCalendar({
          navLinks: false,
          editable: false,
          droppable: false,
          lazyFetching: true,
          eventLimit: true, // allow "more" link when too many events
          header: {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,listMonth'
          },
          eventClick: function (calEvent, jsEvent, view) {
            calendarview = view.name
            console.log('calendarview1 ' + calendarview)
            vm.getMeeting(calEvent.id)
          },
          viewRender: function (view, element) {
            calendarview = view.name
            console.log('calendarview2 ' + calendarview)
            vm.selectDay({ time: view.intervalStart.format('DD-MM-YYYY'), origin: 'calendar' })
          },
          minTime: '06:00:00',
          maxTime: '19:00:00',
          lang: 'fr',
          defaultView: 'agendaWeek',
          events (start, end, timezone, callback) {
            let lastmeeting = 0
            let phasetmp = ''
            vm.getMeetings(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
            .then(() => {
              if (vm.meetings.length === 0) {
                callback(formatMeetingsWithUrl(vm.meetings))
              }
              vm.meetings.forEach(function (meeting) {
                // if (meeting.title === 'null' || meeting.title === null || meeting.title === '') {
                lastmeeting = meeting.id
                // }
              })
              vm.meetings.forEach(function (meeting) {
                // console.log('meeting ' + meeting.id + ' ' + meeting.contact_id)
                if (meeting.title === 'null' || meeting.title === null || meeting.title === '') {
                  meeting.title = ''
                  if (!isNaN(meeting.contact_id) && typeof (meeting.contact_id) === 'number') {
                    vm.contacts.forEach(function (contactTmp) {
                      if (contactTmp.id === meeting.contact_id) {
                        meeting.title = contactTmp.leader_firstname + ' ' + contactTmp.leader_lastname
                      }
                    })
                  }
                  phasetmp = meeting.phase_id
                  vm.phases.forEach(function (phase) {
                    if (phase.id === phasetmp) {
                      if (meeting.title !== '') {
                        meeting.title = meeting.title + ' '
                      }
                      meeting.title = meeting.title + phase.name
                      phasetmp = phase.name
                    }
                  })
                  // Ajouter le parcours s'il existe
                  if (!isNaN(meeting.project_id) && typeof (meeting.project_id) === 'number' && meeting.project_id !== 0) {
                    vm.getProject(meeting.project_id)
                      .then(() => {
                        if (meeting.title !== '') {
                          meeting.title = meeting.title + ' '
                        }
                        meeting.title = meeting.title + vm.project.name
                        meeting.projectname = vm.project.name
                        if (meeting.projectname.indexOf(phasetmp) === -1) {
                          // l'ajouter a la suite si un nom de projet existe
                          meeting.projectname = meeting.projectname + ' ' + phasetmp
                        }
                        if (meeting.id === lastmeeting) {
                          callback(formatMeetingsWithUrl(vm.meetings))
                        }
                      })
                  }
                  if (meeting.title === '') {
                    meeting.title = 'Sans titre et sans participant'
                  }
                }
                if (meeting.id === lastmeeting) {
                  callback(formatMeetingsWithUrl(vm.meetings))
                }
              })
            })
          }
        })
      })
    },
    components: { Breadcrumb },
    computed: {
      title: function () {
        console.log('Computed ')
        if (isNaN(this.title) || this.title === '') {
          return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
        }
      }
    },
    watch: {
      'selectedUsers' () {
        $('.Calendar').fullCalendar('refetchEvents')
      },
      'meetingDeleted' () {
        $('.Calendar').fullCalendar('refetchEvents')
      },
      'selectedDay' (selectedDay) {
        if (selectedDay.origin !== 'calendar') {
          $('.Calendar').fullCalendar('gotoDate', moment(this.selectedDay.time, 'DD-MM-YYYY'))
        }
      }
    }
  }
</script>

<style lang="scss">
  .Calendar{
    height: auto;
    margin: 20px
  }
</style>



// WEBPACK FOOTER //
// Calendar.vue?53bd4d40